import styled from 'styled-components'

import nestleLogoSrc from '../../assets/NestleLogo.png'
import tickLogoSrc from '../../assets/Nestletick.png'

const NestleLogo = styled.img`
  position: absolute;
  display: block;

  width: 28%;
  height: auto;

  max-width: 7em;

  top: 0;
  left: 0;

  z-index: 2;

  padding: 0.5em;

  background: transparent;
`

const TickLogo = styled.img`
  position: absolute;
  display: block;

  width: 11%;
  height: auto;

  max-width: 4em;

  top: 0;
  right: 0;

  z-index: 2;

  padding-right: 0.2em;

  background: transparent;
`
/**
 * Top Logos
 */
const Header = () => {
  return (
    <>
      <NestleLogo src={nestleLogoSrc} className="noselectimg" loading="eager" />
      <TickLogo src={tickLogoSrc} className="noselectimg" loading="eager" />
    </>
  )
}

export default Header
